import styled from 'styled-components'
import { Box } from '../Box'

export const InlineBlock = styled(Box)`
  display: inline-block;
`
